import {Container , Button ,Card ,Row,Col , Image} from 'react-bootstrap'
import {TextField, FormControl , TextareaAutosize} from '@material-ui/core'
import VehicleMoving1 from '../asset/image/vehicle-moving.jpg'
import './VehicleMoving.css'
import SimpleSelect from '../HomeInquire '
import FooterLinks from '../FooterLink';
import { Route, Router } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import { ToastContainer,toast } from 'react-toastify';
import { useState } from 'react';
function VehicleMoving() {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    movingTo: "",
    movingFrom: ""
})
let name, value
const postUserData = (event) => {
    name = event.target.name;
    value = event.target.value;
    setUserData({ ...userData, [name]: value });

}
const submitData = async (event) => {
    event.preventDefault();
    const { firstName, lastName, email, phoneNumber, movingTo, movingFrom } = userData

    if (firstName&&lastName&&email&&phoneNumber&&movingTo&&movingFrom){
        
    const res = fetch("https://infoform-c24b0-default-rtdb.firebaseio.com/homeShifting.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            firstName,
            lastName,
            email,
            phoneNumber,
            movingTo,
            movingFrom
        })

    })
   
    if(res){
        toast.success('Your Form Submitted!', {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            });
        window.location.reload(false);
      
    }
    else{
        alert ("he")
    }  
}
     
        else{
            toast.error('Please Filled All', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                });
        }
   

    

}
    function Qoute(){
        alert("SORRY :  This Service Is Unavailable At This Time")
        }
        
    function  NewsLetters() {
        alert("SORRY :  This Service Is Unavailable At This Time")
      }
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
       }); 
    return(
        <div  style={{backgroundColor:"	 #eee2e2"}}>
        <Container>
                      <Row className="OfficeMovingMain">
                          <Col md={6} className="mt-5">
                          <h1 className="OfficeMovingHeading">Vehicle Moving Service</h1>
                          <p className="mt-5">We can handle all careers services including machinery, cars, <br/> trucks and any other vehicle.</p>
                          <ul>
                              <li>Safe And Secure</li>
                              <li>24/7 Support</li>
                              <li>Live Tracking</li>
                            
                          </ul>
                          <h3 className="OfficeMovingHeading">  +92-3112755732</h3>
                          </Col>
                          <Col md={6} className="mt-5">
                          <Row>
              
              <Col md={5}>
                <TextField id="standard-basic" label="First Name" type="text" name="firstName" value={userData.firstName} onChange={postUserData} />
              </Col>
              <Col md={5}>
                <TextField id="standard-basic" label="Last Name" className="mb-3"  name="lastName"value={userData.lastName} onChange={postUserData}  />
              </Col>
    
              <Col md={5}>
                <TextField id="standard-basic" label="Email" type="mail" name="email" value={userData.email} onChange={postUserData}  />
              </Col>
              <Col md={5}>
                <TextField
                  id="standard-basic"
                  label="Phone Number"
                  type="text"
                  className="mb-3" name="phoneNumber" value={userData.phoneNumber} onChange={postUserData}
                />
              </Col>
    
              <Col md={5}>
                <TextField id="standard-basic" label="City"  name="movingTo" value={userData.movingTo} onChange={postUserData} />
              </Col>
              <Col md={5}>
                <TextField id="standard-basic" label="Country" className="mb-3"  name="movingFrom" value={userData.movingFrom} onChange={postUserData} />
              </Col>
              {/* <Col md={5} className="mb-3" >
                <SimpleSelect />
              </Col> */}
            </Row>                            <ToastContainer  />

                                      <Row>
                                        <Col md={5}><Button
                    type="submit"
                    onClick={submitData}
                    className="OfficeMovingButton"
                  >
                    Submit Form
                  </Button></Col> <br/> <br/>
                                        <Col md={5}><Button type="reset"  onClick={()=>Qoute()} className="OfficeMovingButton">Reset Form</Button></Col>
                                      </Row>
                          </Col>
                      </Row> 
                      <h1>Move You Vehicle More safe and Secure Via Rapid Movers </h1>
                      <Row>
                          <Col md={6}>
                              <p className="VehicleMovingText">
                          A Lahore car carrier that is safe and dependable can be hard to find. If you have a car for moving,
                           you will probably want a carrier service that will meet all of your customized needs, including:</p>
                           <ul>
                               <li>Reliability,</li>
                               <li>Trustworthiness,</li>
                               <li>A well-maintained carrier vehicle,</li>
                               <li>An expert team.  </li>
                           </ul>

                           <p className="VehicleMovingText">Are you looking for a reliable company to move your vehicle from one location to another? Well, your search has come to an end! Rapid Movers provides trustworthy and dependable car carrier services that will check all of the boxes on your list! 
                               You can depend on us to provide you with a cheap car moving service that is also time-efficient.</p>
                               <p className="VehicleMovingText">Vehicle shifting can be a challenging task, and not all companies understand the technicalities that are involved with moving such a large and expensive item. A lot can go wrong in such a process, and this is what puts fears in the hearts of the clients. However, Rapid Movers
                                 has a skilled team that uses full-proof measures to ensure that your vehicle moving process goes as smoothly as possible.</p>
                          </Col>
                          <Col md={6}>
                          <img as={Image}  src={VehicleMoving1}  className="VehicleMovingImage" />
                          </Col>

                      </Row>
                      <p className="VehicleMovingText mt-4">Our car carrier truck is kept well-maintained, and our technicians ensure that each truck is equipped with everything needed to keep your car safe during the transportation process. Rapid Movers 
                          provides car carrier services in Lahore, Islamabad, Karachi, and all other major cities of Lahore.</p>
                          <p className="VehicleMovingText mt-3">Rapid Movers has vehicle shifting services that will leave you without any worries, including the following:

                        </p>   
                        <ul>
                            <li>Car towing,</li>
                            <li>Car moving,</li>
                            <li>Car recovery,</li>
                            <li>And more!</li>
                        </ul>
                      <p  className="VehicleMovingText mt-3">Rapid Movers has several different car carriers available for your needs, including an enclosed car carrier, a single car carrier, a small car carrier, a budget car carrier, and a 3 car carrier. Rapid Movers has accurate vehicle shifting services that will allow you to get your cars from one point to the next in record time. This service is the most useful for people with multiple vehicles who are shifting to another home.</p>
                      <p  className="VehicleMovingText mt-3">No matter how far your destination is, Rapid Movers will make sure to send your cars safely and securely without any hassle. Our transportation drivers are experienced and trained. They also have an in-depth understanding of the auto transport carrier that they drive. Our drivers make sure to drive within the designated speed limit, so your vehicles will always remain safe.</p>
                      <p  className="VehicleMovingText mt-3">Once you contact Rapid Movers, you will be asked a series of questions about the model and dimensions of your car. Then, you can choose from an array of carrier vehicles for your specific needs.</p>
                      <p  className="VehicleMovingText mt-3">Once you have selected the specific service you require, Rapid Movers will walk you through the process. If you are moving house and car, it is likely that you will want to book a car carrier with your final trip to your home. Rapid Movers can remain with you throughout the journey to your final destination, or we can reach there ahead of time. Our services can be customized according to your comfort.</p>
                      <p  className="VehicleMovingText mt-3">Even if you are not moving to a new house, but require a reliable towing company if your car has broken down, contact Rapid Movers. We will reach your destination, to your vehicle, and transport your vehicle to your mechanic with great ease and in minimum time. Most towing services in Pakistan take their time to reach their clients, but Rapid Movers comes to your location in record time!</p>
                      <h5 className="text-center mt-3">Alhamdulilah,  we are providing services with our whole heart! In Shaa Allah, we will never let you down.</h5>
                      </Container>  
                      <footer className="Footer1">
       <Container >
 <Row className="Footer">
   <Col md={3} ><Image src="https://ishfaqmovers.com/wp-content/uploads/2018/10/mo-white.png"  ></Image>
<h6 className="HomeFooterText">ISHFAQ MOVERS has been one of the leading packers &
   Movers in Karachi-Pakistan for more than 10 years. We deliver a broad range of targeted national and 
   international moving services for home, 
  house, villa, apartments, offices as well as relocation solutions for every purpose.</h6>
   </Col>
   <Col md={3} className="mt-3">
     <h3>QUICK LINKS</h3>

     <p><FooterLinks/></p>
 
     <Route path="/about"><FooterLinks/></Route>
     <Route path="/contact"><FooterLinks/></Route>
   </Col>
   <Col md={3}  className="mt-3">
   <h3>OUR SERVICES</h3>
   <p><FooterLinks/></p>
 
 <Route path="/about"><FooterLinks/></Route>
 <Route path="/contact"><FooterLinks/></Route>
   </Col>
   <Col md={3}  className="mt-">
   <h3>NEWSLETTER SIGNUP</h3>
  <h6>No spam, unsubscribe at any time.</h6>
   <TextField id="standard-basic" label="Email" type="mail"  /><br/>
   <Button onClick={()=>NewsLetters()} className="HomeButton mt-2 ">Subscribe</Button>
   <br/>
   <h5   className="mt-2 ">Contact On Social Media</h5>
   <a href="#"><FacebookIcon></FacebookIcon></a>
   <a href="#"><TwitterIcon></TwitterIcon></a>
   <a href="#"><InstagramIcon></InstagramIcon></a>
 
   </Col>
 </Row>
       </Container>
       <hr/>

       </footer>
     </div>
    )
    
}
export default VehicleMoving;